import { createSlice } from "@reduxjs/toolkit";

export const tabelaPrecoSlice = createSlice({
    name: 'tabelaPreco',
    initialState: {
        tabelaPreco: [],
        tabelaPrecoIndividual: [],
        codTpUltConsItem: ''
    },
    reducers: {
        addTabelaPreco: (state, action) => {
            state.tabelaPreco = action.payload
        },
        addTabelaPrecoIndividual: (state, action) => {
            state.tabelaPrecoIndividual = action.payload
        },
        addCodTPUltConsu: (state, action) => {
            state.codTpUltConsItem = action.payload
        }
    }
});

export const { addTabelaPreco, addTabelaPrecoIndividual, addCodTPUltConsu } = tabelaPrecoSlice.actions;
export default tabelaPrecoSlice.reducer; 